































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import GenericDropdown from '@/components/GenericDropdown.vue';                       // @ is an alias to /src
import LeaderboardTeamListComponent from '@/components/LeaderboardTeamListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { Account } from '@/Account'
import { AccountExtra, AccountForLeaderboard } from '@/AccountExtra'
import { IPaginationResult } from '@/PaginationResult'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'LeaderboardTeam',
  components: { GenericDropdown, LeaderboardTeamListComponent, ModalWrapperComponent }
})

export default class LeaderboardTeamComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public teamID: number

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public accounts: AccountForLeaderboard[] = []
  public paginationResult: IPaginationResult = null

  // UI and filter options
  public teams: Array<{ label: string, teamID: number }> = [
    { label: 'Choose a Team', teamID: 0 },
    // { label: '--------------', teamID: 0 },
    { label: 'Atlanta Hawks', teamID: 1610612737 },
    { label: 'Boston Celtics', teamID: 1610612738 },
    { label: 'Brooklyn Nets', teamID: 1610612751 },
    { label: 'Charlotte Hornets', teamID: 1610612766 },
    { label: 'Chicago Bulls', teamID: 1610612741 },
    { label: 'Cleveland Cavaliers', teamID: 1610612739 },
    { label: 'Dallas Mavericks', teamID: 1610612742 },
    { label: 'Denver Nuggets', teamID: 1610612743 },
    { label: 'Detroit Pistons', teamID: 1610612765 },
    { label: 'Golden State Warriors', teamID: 1610612744 },
    { label: 'Houston Rockets', teamID: 1610612745 },
    { label: 'Indiana Pacers', teamID: 1610612754 },
    { label: 'LA Clippers', teamID: 1610612746 },
    { label: 'Los Angeles Lakers', teamID: 1610612747 },
    { label: 'Memphis Grizzlies', teamID: 1610612763 },
    { label: 'Miami Heat', teamID: 1610612748 },
    { label: 'Milwaukee Bucks', teamID: 1610612749 },
    { label: 'Minnesota Timberwolves', teamID: 1610612750 },
    { label: 'New Orleans Pelicans', teamID: 1610612740 },
    { label: 'New York Knicks', teamID: 1610612752 },
    { label: 'Oklahoma City Thunder', teamID: 1610612760 },
    { label: 'Orlando Magic', teamID: 1610612753 },
    { label: 'Philadelphia 76ers', teamID: 1610612755 },
    { label: 'Phoenix Suns', teamID: 1610612756 },
    { label: 'Portland Trail Blazers', teamID: 1610612757 },
    { label: 'Sacramento Kings', teamID: 1610612758 },
    { label: 'San Antonio Spurs', teamID: 1610612759 },
    { label: 'Toronto Raptors', teamID: 1610612761 },
    { label: 'Utah Jazz', teamID: 1610612762 },
    { label: 'Washington Wizards', teamID: 1610612764 },
    { label: '------------------', teamID: 0 },
    { label: 'Atlanta Dream', teamID: 1611661330 },
    { label: 'Chicago Sky', teamID: 1611661329 },
    { label: 'Connecticut Sun', teamID: 1611661323 },
    { label: 'Dallas Wings', teamID: 1611661321 },
    { label: 'Indiana Fever', teamID: 1611661325 },
    { label: 'Las Vegas Aces', teamID: 1611661319 },
    { label: 'Los Angeles Sparks', teamID: 1611661320 },
    { label: 'Minnesota Lynx', teamID: 1611661324 },
    { label: 'New York Liberty', teamID: 1611661313 },
    { label: 'Phoenix Mercury', teamID: 1611661317 },
    { label: 'Seattle Storm', teamID: 1611661328 },
    { label: 'Washington Mystics', teamID: 1611661322 },
  ]

  public team: { label: string, teamID: number } = this.teams[0]


  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  @Watch('team')
  public async onChangedTeam(team: { label: string, teamID: number }) {
    this.team = team ? team : this.teams[0]
    this.accounts = []
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`LeaderboardTeamComponent.pathChanged() ${this.$route.path}`)
  }

  private getTeamFromTeamID(teamID: number): { label: string, teamID: number } {
    for (const team of this.teams) if (team.teamID === teamID) return team
    return null
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    utils_tracker.page(this.$options.name)

    // from props
    if (this.teamID) this.team = this.getTeamFromTeamID(this.teamID)

    // from url
    console.log(`mounted(): Got ${this.$route.query.teamID} from url`)
    if (this.$route.query.teamID) {
      this.team = this.getTeamFromTeamID(Number(this.$route.query.teamID))
    }

    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // add mode and flowAddress as query params to current url path
  private addParamsToURL() {
    if (!this.$route.path.includes('/team')) return
    let extra: string = ''
    if (this.team && this.team.teamID) {
      extra += `&teamID=${this.team.teamID}`
      extra = extra.replace('&', '?')     // replace only the first one
      this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
    }
  }

  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    if (!this.team || !this.team.teamID) return 0

    const fakeAccount: AccountForLeaderboard = {
      accountExtra: new AccountExtra(null, 'fake', 'fake'),
      account: null
    }

    let url: string = utils.getURLprefix() + `/api/topshot/leaderboards/team/${this.team.teamID}`;
    url += `?page=${pageNumberWhenCalled}`;

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`LeaderboardTeamComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;

    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the accounts
      let newRawItems: AccountForLeaderboard[] = response.data.accounts
      if (newRawItems) {
        const newHydratedItems: AccountForLeaderboard[] = []
        for (const po of newRawItems) newHydratedItems.push({ account: new Account(po.account), accountExtra: new AccountExtra(po.accountExtra)})
        if (pageNumberWhenCalled === 1) this.accounts = [ fakeAccount ].concat(newHydratedItems);
        else this.accounts = this.accounts.concat(newHydratedItems)

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    this.$store.commit("setLoading", { loading: false });
  }  
}
